// ============================================
// FILE: src/components/Footer.jsx
// ============================================
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-white rounded-xl p-1">
                <img 
                  src="/images/sai_logo.png" 
                  alt="Shree Sai Properties Logo" 
                  className="w-12 h-12 object-contain"
                />
              </div>
              <span className="font-bold text-xl text-white">Shree Sai Properties</span>
            </div>
            <p className="text-sm text-gray-400 mb-4">Your trusted real estate partner since 2012. We help you find, buy, rent, and manage properties with complete legal support.</p>
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/shreesaip/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition"
              >
                <FaFacebook size={18} />
              </a>
              <a 
                href="https://www.instagram.com/shreesaiproperties/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition"
              >
                <FaInstagram size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition"
              >
                <FaLinkedin size={18} />
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/rent" className="hover:text-amber-400 transition">Properties for Rent</Link></li>
              <li><Link to="/sale" className="hover:text-amber-400 transition">Properties for Sale</Link></li>
              <li><Link to="/buy" className="hover:text-amber-400 transition">Buy Property</Link></li>
              
              <li><Link to="/dealers" className="hover:text-amber-400 transition">Dealer Network</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Legal & Docs</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/agreements" className="hover:text-amber-400 transition">Rental Agreement</Link></li>
              <li><Link to="/documents" className="hover:text-amber-400 transition">Property Documents</Link></li>
              <li className="hover:text-amber-400 transition cursor-pointer">Sale Deed Drafting</li>
              <li className="hover:text-amber-400 transition cursor-pointer">Encumbrance Certificate</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2"><Phone size={16} /> +91 9764646044</li>
              <li className="flex items-center gap-2"><Mail size={16} />saipropertiesandfinance@gmail.com</li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" /> 
                <span>Survey No 298, Nirvana Lifecity, Office No. B-12, opposite Kohinoor Viva City, Lohegaon, Pune, Maharashtra 411047</span>
              </li>
            </ul>
            <Link to="/inquiry" className="inline-block mt-4 bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition">Quick Inquiry</Link>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-xs text-gray-500">
          © 2026 Shree Sai Properties — All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;